/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { RequestStatus } from '../models/RequestStatus';
import { SimpleUser } from '../models/SimpleUser';
import { HttpFile } from '../http/http';

export class SafetyTrackingTeamInvite {
    'id': number;
    'invited': SimpleUser;
    'inviter': SimpleUser;
    'status'?: RequestStatus;
    'dtCreated': Date;
    'text'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "number",
            "format": ""
        },
        {
            "name": "invited",
            "baseName": "invited",
            "type": "SimpleUser",
            "format": ""
        },
        {
            "name": "inviter",
            "baseName": "inviter",
            "type": "SimpleUser",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "RequestStatus",
            "format": ""
        },
        {
            "name": "dtCreated",
            "baseName": "dtCreated",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "text",
            "baseName": "text",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return SafetyTrackingTeamInvite.attributeTypeMap;
    }

    public constructor() {
    }
}



